const usePermissions = (permissionList: any) => {
  // access
  const canAccessStock = permissionList.stock.read
  const canAccessAttendu = permissionList.attendu.read
  const canAccessCommande = permissionList.commande.read
  const canAccessReference = permissionList.reference.read
  const canAccessMission = permissionList.mission.read
  const canAccessHistory = permissionList.history.read
  const canAccessClient = permissionList.client.read
  const canAccessUser = permissionList.user.read
  const canAccessCompany = permissionList.company.read
  const canAccessWarehouse = permissionList.warehouse.read
  const canAccessBilling = permissionList.billing.read
  const canAccessInventory = permissionList.inventory?.read
  const canAccessFournisseur = permissionList.fournisseur?.read
  const canAccessTransporteur = permissionList.transporteur?.read
  const canAccessDestinataire = permissionList.destinataire?.read
  const canAccessSupport = permissionList.support?.read
  const canAccessPrinter = permissionList.printer?.read
  const canAccessPrintingPolicy = permissionList.printing_policy?.read
  const canAccessDatabaseTable = permissionList.database_table?.read
  const canAccessFTP = permissionList.ftp?.read
  //create
  const canCreateAttendu = permissionList.attendu.create
  const canCreateCommande = permissionList.commande.create
  const canCreateReference = permissionList.reference.create
  const canCreateClient = permissionList.client.create
  const canCreateUser = permissionList.user.create
  const canCreateCompany = permissionList.company.create
  const canCreateFournisseur = permissionList.fournisseur?.create
  const canCreateTransporteur = permissionList.transporteur?.create
  const canCreateDestinataire = permissionList.destinataire?.create
  const canCreateSupport = permissionList.support?.create
  const canCreatePrinter = permissionList.printer?.create
  const canCreatePrintingPolicy = permissionList.printing_policy?.create
  const canCreateInventory = permissionList.inventory?.create
  const canCreateFTP = permissionList.ftp?.create
  // update
  const canUpdateStock = permissionList.stock.update
  const canUpdateAttendu = permissionList.attendu.update
  const canUpdateCommande = permissionList.commande.update
  const canUpdateReference = permissionList.reference.update
  const canUpsertStockMission = permissionList.mission.upsert_stock
  const canUpsertAttenduMission = permissionList.mission.upsert_attendu
  const canUpsertCommandeMission = permissionList.mission.upsert_commande
  const canUpdateClient = permissionList.client.update
  const canUpdateUser = permissionList.user.update
  const canUpdateCompany = permissionList.company.update
  const canUpdateFournisseur = permissionList.fournisseur?.update
  const canUpdateTransporteur = permissionList.transporteur?.update
  const canUpdateDestinataire = permissionList.destinataire?.update
  const canUpdateSupport = permissionList.support?.update
  const canUpdatePrinter = permissionList.printer?.update
  const canUpdatePrintingPolicy = permissionList.printing_policy?.update
  const canUpdateInventory = permissionList.inventory?.update
  const canUpdateFTP = permissionList.ftp?.update
  // delete
  const canDeleteReference = permissionList.reference.delete
  const canDeleteAttendu = permissionList.attendu.delete
  const canDeleteCommande = permissionList.commande.delete
  const canDeleteStockMission = permissionList.mission.delete_stock
  const canDeleteAttenduMission = permissionList.mission.delete_attendu
  const canDeleteCommandeMission = permissionList.mission.delete_commande
  const canDeleteClient = permissionList.client.delete
  const canDeleteUser = permissionList.user.delete
  const canDeleteCompany = permissionList.company.delete
  const canDeleteFournisseur = permissionList.fournisseur?.delete
  const canDeleteTransporteur = permissionList.transporteur?.delete
  const canDeleteDestinataire = permissionList.destinataire?.delete
  const canDeleteSupport = permissionList.support?.delete
  const canDeletePrintingPolicy = permissionList.printing_policy?.delete
  const canDeleteInventory = permissionList.inventory?.delete
  const canDeleteFTP = permissionList.ftp?.delete
  // import
  const canImportReference = permissionList.reference.import
  const canImportAttendu = permissionList.attendu.import
  const canImportCommande = permissionList.commande.import
  // export
  const canExportStock = permissionList.stock.export
  const canExportAttendu = permissionList.attendu.export
  const canExportCommande = permissionList.commande.export
  const canExportReference = permissionList.reference.export
  const canExportClient = permissionList.client.export
  const canExportUser = permissionList.reference.export
  const canExportCompany = permissionList.user.export
  const canAccessParametres = true
  const canExportInventory = permissionList.inventory?.export

  return {
    // access
    canAccessStock,
    canAccessAttendu,
    canAccessCommande,
    canAccessReference,
    canAccessMission,
    canAccessHistory,
    canAccessClient,
    canAccessUser,
    canAccessCompany,
    canAccessWarehouse,
    canAccessBilling,
    canAccessInventory,
    canAccessFournisseur,
    canAccessTransporteur,
    canAccessDestinataire,
    canAccessParametres,
    canAccessPrinter,
    canAccessSupport,
    canAccessPrintingPolicy,
    canAccessDatabaseTable,
    canAccessFTP,
    //create
    canCreateReference,
    canCreateAttendu,
    canCreateCommande,
    canCreateClient,
    canCreateUser,
    canCreateCompany,
    canCreateTransporteur,
    canCreateDestinataire,
    canCreateFournisseur,
    canCreateSupport,
    canCreatePrinter,
    canCreatePrintingPolicy,
    canCreateInventory,
    canCreateFTP,
    // update
    canUpdateStock,
    canUpdateAttendu,
    canUpdateCommande,
    canUpdateReference,
    canUpsertStockMission,
    canUpsertAttenduMission,
    canUpsertCommandeMission,
    canUpdateClient,
    canUpdateUser,
    canUpdateCompany,
    canUpdateTransporteur,
    canUpdateDestinataire,
    canUpdateFournisseur,
    canUpdateSupport,
    canUpdatePrinter,
    canUpdatePrintingPolicy,
    canUpdateInventory,
    canUpdateFTP,
    // delete
    canDeleteReference,
    canDeleteAttendu,
    canDeleteCommande,
    canDeleteStockMission,
    canDeleteAttenduMission,
    canDeleteCommandeMission,
    canDeleteClient,
    canDeleteUser,
    canDeleteCompany,
    canDeleteTransporteur,
    canDeleteDestinataire,
    canDeleteFournisseur,
    canDeleteSupport,
    canDeletePrintingPolicy,
    canDeleteInventory,
    canDeleteFTP,
    // import
    canImportReference,
    canImportAttendu,
    canImportCommande,
    // export
    canExportStock,
    canExportAttendu,
    canExportCommande,
    canExportReference,
    canExportClient,
    canExportUser,
    canExportCompany,
    canExportInventory,
  }
}

export default usePermissions
